export default "__VITE_ASSET__DASRxCYH__"